import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import {
  AgrPageDetailModule,
  AgrValueRowModule,
  AgrResponsiveActionsModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrSharedModule } from '@next/core-lib/shared';

import { CropAidModule } from '../crop-aid/crop-aid.module';
import { LegalRestrictionModule } from '../legal-restriction/legal-restriction.module';
import { SoilTypeModule } from '../soil-type/soil-type.module';
import { CopyTemplatesByYearDialogComponent } from './components/copy-templates-by-year-dialog/copy-templates-by-year-dialog.component';
import { CopyTreatmentsDialogComponent } from './components/copy-treatments-dialog/copy-treatments-dialog.component';

import { CreateNitrogenModelPropertyDialogComponent } from './components/create-nitrogen-model-property-dialog/create-nitrogen-model-property-dialog.component';
import { CreateNutrientPropertyDialogComponent } from './components/create-nutrient-property-dialog/create-nutrient-property-dialog.component';
// eslint-disable-next-line max-len
import { CreateProductionPurposeCategoryDialogComponent } from './components/create-production-purpose-category-dialog/create-production-purpose-category-dialog.component';
import { CreateTemplateDialogComponent } from './components/create-template-dialog/create-template-dialog.component';
import { CreateVarietyPropertyDialogComponent } from './components/create-variety-property-dialog/create-variety-property-dialog.component';
import { LegalRestrictionInfoComponent } from './components/legal-restriction-info/legal-restriction-info.component';
import { TreatmentDialogComponent } from './components/treatment-dialog/treatment-dialog.component';
import { TreatmentSchemaDialogComponent } from './components/treatment-schema-dialog/treatment-schema-dialog.component';
import { DecimalSeparatorDirective } from './directives/decimal-separator.directive';
import { TemplateFoundGuard } from './guards/template-found.guard';

@NgModule({
  declarations: [
    CreateTemplateDialogComponent,
    CreateNutrientPropertyDialogComponent,
    CreateVarietyPropertyDialogComponent,
    CreateNitrogenModelPropertyDialogComponent,
    TreatmentDialogComponent,
    TreatmentSchemaDialogComponent,
    CopyTreatmentsDialogComponent,
    CopyTemplatesByYearDialogComponent,
    LegalRestrictionInfoComponent,
    DecimalSeparatorDirective,
    CreateProductionPurposeCategoryDialogComponent,
  ],
  imports: [
    AgrSharedModule,
    CropAidModule,
    SoilTypeModule,
    LegalRestrictionModule,
    MatChipsModule,
    MatSelectModule,
    MatIconModule,
    MatDividerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    AgrValueRowModule,
    AgrDialogModule,
    AgrPageDetailModule,
    AgrResponsiveActionsModule,
    MatListModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatButtonModule,
    MatTableModule,
  ],
  exports: [AgrSharedModule, MatChipsModule, DecimalSeparatorDirective],
  providers: [TemplateFoundGuard],
})
export class SharedModule {}
